import { PhaserButton, PhaserButtonConfig } from 'src/games/shared/Button';
import { DrawBloodScene } from '../scenes/DrawBloodScene';
import { SickCellInfoScene } from '../scenes/SickCellInfoScene';
import { SickCellsScene } from '../scenes/SickCellsScene';
import { BacteriaInfoScene } from '../scenes/BacteriaInfoScene';
import { CountBacteriaScene } from '../scenes/CountBacteriaScene';
import { TestTubeInfoScene } from '../scenes/TestTubeInfoScene';
import { TestTubeScene } from '../scenes/TestTubeScene';
import { ColorChangerInfoScene } from '../scenes/ColorChangerInfoScene';
import { ColorChangerScene } from '../scenes/ColorChangerScene';
import { GameState } from './GameState';
import { Color } from 'src/games/shared/ColorValue';
import { DiagnosisScene } from '../scenes/DiagnosisScene';
import { GameOverScene } from '../scenes/GameOverScene';
import TranslateApi from 'src/utils/TranslateHelper';
import { SceneObject } from "src/games/shared/SceneObject";

export class Helpers {
    private static GAME_WIDTH = 1360;
    private static GAME_HEIGHT = 768;
    private static translateString: string = "Diagnosis.Phaser.Helpers.";

    /**
     * Defines the ordering of the game scenes for Lab Diagnosis game
     * Used for the next button
     */
    public static SCENE_ORDER: SceneObject[] = [
        { key: "DrawBloodScene", scene: DrawBloodScene },
        { key: "ColorChangerInfoScene", scene: ColorChangerInfoScene },
        { key: "ColorChangerScene", scene: ColorChangerScene },
        { key: "SickCellInfoScene", scene: SickCellInfoScene },
        { key: "SickCellsScene", scene: SickCellsScene },
        { key: "BacteriaInfoScene", scene: BacteriaInfoScene },
        { key: "CountBacteriaScene", scene: CountBacteriaScene },
        { key: "TestTubeInfoScene", scene: TestTubeInfoScene },
        { key: "TestTubeScene", scene: TestTubeScene },
        { key: "DiagnosisScene", scene: DiagnosisScene },
        { key: "GameOverScene", scene: GameOverScene },
    ];

    public static createButton(scene: Phaser.Scene, x: number, y: number, color: number, text: string): PhaserButton {
        var config = new PhaserButtonConfig();
        config.backgroundColor = color;
        var button = new PhaserButton(scene, x, y, 200, 80, text, config);
        return button;
    }

    /**
     * Fades the target image out to invisible
     * Called before setting the new color to simulate changing colors
     */
    public static fadeOut(scene: Phaser.Scene, target: Phaser.GameObjects.Image, duration: number, start: number, end: number): void {
        scene.tweens.add({
            targets: target,
            ease: "Power1",
            duration: duration,
            alpha: {
                getStart: () => start,
                getEnd: () => end
            },
        });
    }

    public static flashObject(scene: Phaser.Scene, target: Phaser.GameObjects.Image): void {
        scene.tweens.add({
            targets: target,
            alpha: {
                value: 0.3,
                duration: 600,
            },
            yoyo: true,
            repeat: -1,
        });
    }


    /**
     * Gets an array of unique random colors
     */
    public static getRandomUniqueColors(count: number): number[] {
        let actualColors = [
            Color.COLORS.get("red"),
            Color.COLORS.get("blue"),
            Color.COLORS.get("green"),
            Color.COLORS.get("yellow"),
            Color.COLORS.get("orange"),
            Color.COLORS.get("purple"),
            Color.COLORS.get("teal"),
            Color.COLORS.get("pink"),
        ];
        var colors = [];
        while (colors.length < count) {
            var randomIndex = Phaser.Math.Between(0, actualColors.length - 1);
            if (colors.indexOf(actualColors[randomIndex]) === -1) {
                colors.push(actualColors[randomIndex]);
            }
        }
        return colors;
    }

    /**
    * Shuffle the candidates so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    public static scrambleArray(array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    }

    /**
     * Get next scene in the game
     */
    public static getNextScene(sceneNumber: number) {
        var nextSceneObject = this.SCENE_ORDER[sceneNumber];
        return nextSceneObject;
    }

    public static addNextButton(currentScene: Phaser.Scene): void {
        let text = TranslateApi.translate("common.next");
        let config = { backgroundColor: Color.KUDER_PRIMARY_BUTTON, textColor: 0xffffff, textSize: 20, smartSize: true, keyMapping: "keydown_RIGHT" };
        let next = new PhaserButton(currentScene, this.GAME_WIDTH - 150, this.GAME_HEIGHT - 75, 150, 50, text, config);
        next.setX(this.GAME_WIDTH - next.width - 50);
        next.on('buttonClicked', () => {
            currentScene.scene.setActive(false);
            currentScene.scene.remove(currentScene);
            var nextSceneObject = Helpers.getNextScene(GameState.current.sceneNumber);
            GameState.current.sceneNumber += 1;
            if (nextSceneObject != null) {
                currentScene.scene.add(nextSceneObject.key, nextSceneObject.scene, true);
            }
        });
    }

    public static getPreviousScene(sceneNumber: number) {
        // Get previous scene number, offset by 1 because of 0 indexing
        var previousSceneObject = this.SCENE_ORDER[sceneNumber - 2];
        return previousSceneObject;
    }

    public static addBackButton(currentScene: Phaser.Scene): void {
        let text = TranslateApi.translate("common.back");
        let config = { backgroundColor: Color.KUDER_SECONDARY_BUTTON, textColor: 0xffffff, textSize: 20, smartSize: true, keyMapping: "keydown_LEFT" };
        let back = new PhaserButton(currentScene, 50, this.GAME_HEIGHT - 75, 100, 50, text, config);
        back.on('buttonClicked', () => {
            currentScene.scene.setActive(false);
            currentScene.scene.remove(currentScene);
            var previousSceneObject = Helpers.getPreviousScene(GameState.current.sceneNumber);
            GameState.current.sceneNumber -= 1;
            if (previousSceneObject != null) {
                currentScene.scene.add(previousSceneObject.key, previousSceneObject.scene, true);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/objects/Helpers.ts